(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["valca-beautyweek"] && !Shopify.designMode) return;
  try {
    
/* VALCA Beauty Week. Recomendador local; no modifica carrito, precios ni bundles. */
(function () {
  'use strict';

  const experience = {
    title: '¿Ya usás productos VALCA?',
    options: [
      { value: 'new', label: 'Sería mi primer kit' },
      { value: 'known', label: 'Sí, ya uso VALCA' }
    ]
  };

  function questionFor(answers, configuredKeys) {
    if (!answers.length) return {
      title: '¿Qué querés cuidar hoy?',
      options: [
        { value: 'skin', label: 'Mi piel' },
        { value: 'striae', label: 'Mis estrías' },
        { value: 'intimate', label: 'Mi zona íntima' },
        { value: 'hair', label: 'Mi cabello' }
      ].filter(option => option.value !== 'hair' || !configuredKeys || configuredKeys.includes('capilar'))
    };
    if (answers.length === 1) {
      if (answers[0] === 'hair') return {
        title: '¿Qué querés acompañar con tu rutina?',
        options: [
          { value: 'fall', label: 'La caída del cabello' },
          { value: 'volume', label: 'La falta de fuerza o volumen' }
        ]
      };
      if (answers[0] === 'skin') return {
        title: '¿Qué buscás para tu piel?',
        options: [
          { value: 'daily', label: 'Cuidado diario', note: 'Una combinación sencilla' },
          { value: 'combined', label: 'Diario + intensivo', note: 'Sumar ambos cuidados' }
        ]
      };
      if (answers[0] === 'striae') return {
        title: '¿Querés sumar otro cuidado?',
        options: [
          { value: 'focused', label: 'Me enfoco en mis estrías' },
          { value: 'intensive', label: 'También cuidado intensivo de la piel' },
          { value: 'external', label: 'También cuidado íntimo externo' }
        ]
      };
      return {
        title: '¿También querés cuidar tus estrías?',
        options: [
          { value: 'focused', label: 'Solo cuidado íntimo externo' },
          { value: 'body', label: 'Sí, también mis estrías' }
        ]
      };
    }
    if (answers[0] === 'skin' && answers[1] === 'combined') return {
      title: '¿Qué cantidad va con tu rutina?',
      options: [
        { value: 'compact', label: 'Un kit compacto', note: 'Ambas ceras en 50 g' },
        { value: 'ultra', label: 'Más de la intensiva', note: 'Ultra 130 g + Reg. 50 g' },
        { value: 'both', label: 'Más de ambas', note: 'Ambas ceras en 130 g' }
      ]
    };
    if (answers[0] === 'striae' && answers[1] === 'focused') return {
      title: '¿Qué cantidad preferís?',
      options: [
        { value: 'single', label: 'Una crema de Estrías', note: '200 g + Pocket' },
        { value: 'stock', label: 'Tener más cantidad', note: '3 de 200 g + Pocket' }
      ]
    };
    if ((answers[0] === 'striae' && answers[1] === 'external') || (answers[0] === 'intimate' && answers[1] === 'body')) return {
      title: '¿Querés sumar cuidado intensivo de la piel?',
      options: [
        { value: 'simple', label: 'Me alcanza con Estrías + Íntima' },
        { value: 'intensive', label: 'Sí, quiero sumar Ultra Regeneradora' }
      ]
    };
    if (answers[0] === 'hair') return {
      title: '¿En qué momento de tu rutina estás?',
      options: [
        { value: 'start', label: 'Quiero empezar a cuidarlo' },
        { value: 'continue', label: 'Quiero completar mi cuidado' }
      ]
    };
    return experience;
  }

  function resultFor(answers) {
    if (answers.length !== 3) return null;
    // Validate each answer against the actual adaptive path.
    for (let i = 0; i < 3; i += 1) {
      if (!questionFor(answers.slice(0, i)).options.some(o => o.value === answers[i])) return null;
    }
    const [need, context, preference] = answers;
    let key;
    let reason;
    let alternatives = [];
    if (need === 'hair') {
      key = 'capilar';
      reason = context === 'fall'
        ? 'Querés acompañar la caída del cabello con una rutina de dos pasos: Shampoo Anticaída 200 ml y Loción Anticaída 80 ml.'
        : 'Buscás cuidar la fuerza y el volumen de tu cabello: este kit combina Shampoo Anticaída 200 ml y Loción Anticaída 80 ml.';
    } else if (need === 'skin' && context === 'daily') {
      key = 'proteccion';
      reason = 'Buscás una combinación sencilla para el cuidado diario: Regeneradora 50 g y Pocket 10 ml para llevar con vos.';
    } else if (need === 'skin') {
      key = { compact: 'total', ultra: 'ultra', both: 'mega' }[preference];
      alternatives = ['total', 'mega', 'ultra'].filter(k => k !== key);
      reason = {
        total: 'Elegiste combinar cuidado diario e intensivo en un kit compacto: Regeneradora 50 g, Ultra 50 g y Pocket 10 ml.',
        ultra: 'Querés ambos cuidados y más cantidad de la cera intensiva: Ultra 130 g, Regeneradora 50 g y Pocket 10 ml.',
        mega: 'Preferís más cantidad para sostener ambos cuidados: Regeneradora y Ultra en 130 g, más Pocket 10 ml.'
      }[key];
    } else if (need === 'striae' && context === 'focused') {
      key = preference === 'stock' ? 'estriasTres' : 'estriasPocket';
      alternatives = [key === 'estriasTres' ? 'estriasPocket' : 'estriasTres'];
      reason = preference === 'stock'
        ? 'Tu prioridad son las estrías y preferís tener más cantidad: tres cremas de 200 g y un Pocket de 10 ml.'
        : 'Querés enfocarte en tus estrías con una crema de 200 g y sumar Pocket de 10 ml para llevar.';
    } else if (need === 'striae' && context === 'intensive') {
      key = 'estriasUltra';
      reason = 'Querés cuidar tus estrías y sumar cuidado intensivo de la piel: Estrías 200 g y Ultra Regeneradora 50 g.';
    } else if ((need === 'striae' && context === 'external') || (need === 'intimate' && context === 'body')) {
      key = preference === 'simple' ? 'sinTabues' : 'femenina';
      reason = preference === 'simple'
        ? 'Elegiste combinar cuidado de estrías y confort íntimo externo: Estrías 200 g e Íntima 50 ml, en una rutina de dos productos.'
        : 'Querés combinar cuidado de estrías, confort íntimo externo y cuidado intensivo de la piel: Estrías 200 g, Íntima 50 ml y Ultra Regeneradora 50 g.';
    } else {
      key = 'equilibrio';
      reason = 'Elegiste enfocarte en el cuidado íntimo externo: este kit reúne Íntima 50 ml y Ultra Regeneradora 50 g.';
    }
    const experienceNote = need === 'hair'
      ? (preference === 'start'
        ? 'Para empezar, en la ficha del kit encontrás cómo integrar shampoo y loción a tu rutina.'
        : 'Revisá cómo sumar ambos pasos a tu cuidado actual: la constancia acompaña el proceso.')
      : preference === 'new'
      ? 'Para tu primer kit VALCA, en la ficha encontrás qué aporta cada producto y cómo se usa.'
      : preference === 'known'
        ? 'Podés revisar las presentaciones incluidas y elegir la oferta que acompañe tu rutina actual.'
        : '';
    return { key, alternatives, reason, experienceNote };
  }

  function chooseAvailable(result, availableKeys) {
    if (!result) return null;
    const available = new Set(availableKeys);
    if (available.has(result.key)) return { ...result, fallback: false };
    const substitute = result.alternatives.find(key => available.has(key));
    return substitute ? {
      ...result,
      key: substitute,
      fallback: true,
      reason: 'La presentación que elegiste no está disponible. Este kit reúne los mismos tipos de productos en otra cantidad; revisá los tamaños incluidos antes de elegir.'
    } : null;
  }

  // This export exists only for the local route/availability checks, never in Shopify.
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { questionFor, resultFor, chooseAvailable };
  }
  if (typeof document === 'undefined') return;

  function element(tag, className, value) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (value !== undefined) node.textContent = value;
    return node;
  }

  function init(root) {
    if (root.dataset.bwInitialized) return;
    const grid = root.querySelector('[data-bw-grid]');
    const cards = Array.from(root.querySelectorAll('[data-bw-card]'));
    if (!grid || !cards.length) return;
    const quiz = root.querySelector('[data-bw-quiz]');
    const launcher = root.querySelector('[data-bw-launcher]');
    const start = root.querySelector('[data-bw-start]');
    const close = root.querySelector('[data-bw-close]');
    if (!quiz || !launcher || !start || !close) return;
    root.dataset.bwInitialized = 'true';
    const startLabel = start.textContent;
    const intro = root.querySelector('[data-bw-intro]');
    const question = root.querySelector('[data-bw-question]');
    const status = root.querySelector('[data-bw-status]');
    const gridNote = root.querySelector('[data-bw-grid-note]');
    const originalNote = '';
    gridNote.textContent = '';
    gridNote.hidden = true;
    const products = new Map();
    cards.forEach(card => {
      const key = card.dataset.key;
      if (!products.has(key)) products.set(key, {
        card, key,
        title: card.dataset.title,
        url: card.querySelector('[data-bw-product-link]')?.getAttribute('href') || null,
        demo: card.dataset.demo === 'true',
        available: card.dataset.available === 'true'
      });
    });
    let answers = [];
    let previousAnswers = [];

    function resetCards() {
      cards.forEach(card => {
        card.classList.remove('is-recommended');
        card.querySelector('[data-bw-badge]').hidden = true;
        grid.appendChild(card);
      });
      gridNote.textContent = originalNote;
      gridNote.hidden = true;
    }

    function reset() {
      answers = [];
      previousAnswers = [];
      resetCards();
      renderQuestion(true);
    }

    function renderQuestion(focus) {
      const q = questionFor(answers, Array.from(products.keys()));
      quiz.dataset.bwStep = String(answers.length + 1);
      question.replaceChildren();
      intro.hidden = answers.length > 0;
      const top = element('div', 'bw-q-top');
      const heading = element('h3', '', q.title);
      heading.id = root.id + '-question';
      heading.tabIndex = -1;
      top.append(heading, element('span', 'bw-step', (answers.length + 1) + ' de 3'));
      if (answers.length) {
        const back = element('button', 'bw-text-button', 'Volver');
        back.type = 'button';
        back.addEventListener('click', () => {
          answers = answers.slice(0, -1);
          renderQuestion(true);
        });
        top.appendChild(back);
      }
      const options = element('div', 'bw-q-options bw-q-options--' + q.options.length);
      options.setAttribute('role', 'group');
      options.setAttribute('aria-labelledby', heading.id);
      q.options.forEach(option => {
        const button = element('button', 'bw-answer');
        button.type = 'button';
        const label = element('span', '', option.label);
        if (option.note) label.appendChild(element('small', '', option.note));
        button.appendChild(label);
        button.setAttribute('aria-pressed', String(previousAnswers[answers.length] === option.value));
        button.addEventListener('click', () => {
          answers.push(option.value);
          previousAnswers = answers.slice();
          if (answers.length === 3) renderResult();
          else renderQuestion(true);
        });
        options.appendChild(button);
      });
      question.append(top, options);
      status.textContent = '';
      if (focus) heading.focus({ preventScroll: true });
    }

    function renderResult() {
      quiz.dataset.bwStep = 'result';
      const availableKeys = [...products.values()].filter(p => p.available).map(p => p.key);
      const result = chooseAvailable(resultFor(answers), availableKeys);
      resetCards();
      intro.hidden = true;
      question.replaceChildren();
      const container = element('div', 'bw-result');
      const copy = element('div', 'bw-result-copy');
      const heading = element('h3');
      heading.tabIndex = -1;
      const actions = element('div', 'bw-result-actions');
      if (result) {
        const product = products.get(result.key);
        copy.appendChild(element('div', 'bw-result-eyebrow', result.fallback ? 'Otra presentación disponible' : 'Tu kit recomendado'));
        heading.textContent = product.title;
        copy.append(heading, element('p', '', result.reason));
        if (result.experienceNote) copy.appendChild(element('p', 'bw-result-context', result.experienceNote));
        const link = element(product.demo ? 'button' : 'a', 'bw-primary', product.demo ? 'Ver kit de prueba ↓' : result.fallback ? 'Ver esta opción ↗' : 'Ver mi kit ↗');
        if (product.demo) {
          link.type = 'button';
          link.addEventListener('click', () => {
            product.card.scrollIntoView({ block: 'start', behavior: 'auto' });
            product.card.focus({ preventScroll: true });
          });
          copy.appendChild(element('p', 'bw-result-context', 'Vista de prueba: el producto Shopify se vinculará después de crearlo.'));
        } else link.href = product.url;
        actions.appendChild(link);
        product.card.classList.add('is-recommended');
        const badge = product.card.querySelector('[data-bw-badge]');
        badge.textContent = result.fallback ? 'OTRA PRESENTACIÓN' : 'PARA VOS';
        badge.hidden = false;
        grid.prepend(product.card);
        gridNote.textContent = result.fallback ? 'Otra presentación disponible' : 'Tu kit recomendado';
        gridNote.hidden = false;
        status.textContent = 'Resultado listo. ' + product.title;
      } else {
        heading.textContent = 'Tu combinación no está disponible ahora';
        copy.append(heading, element('p', '', 'Podés explorar los kits disponibles abajo o cambiar tus respuestas.'));
        const explore = element('button', 'bw-primary', 'Ver los kits ↓');
        explore.type = 'button';
        explore.addEventListener('click', () => {
          const first = cards.find(card => card.dataset.available === 'true') || cards[0];
          first.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          first.focus({ preventScroll: true });
        });
        actions.appendChild(explore);
        status.textContent = 'No hay un kit disponible para esta combinación.';
      }
      const change = element('button', 'bw-text-button', 'Cambiar respuestas');
      change.type = 'button';
      change.addEventListener('click', reset);
      actions.appendChild(change);
      container.append(copy, actions);
      question.appendChild(container);
      heading.focus({ preventScroll: true });
    }
    function closeQuiz() {
      quiz.hidden = true;
      launcher.hidden = false;
      start.setAttribute('aria-expanded', 'false');
      start.textContent = answers.length === 3 ? 'Ver mi recomendación' : answers.length ? 'Continuar mi quiz' : startLabel;
      start.focus({ preventScroll: true });
    }
    start.addEventListener('click', () => {
      launcher.hidden = true;
      quiz.hidden = false;
      start.setAttribute('aria-expanded', 'true');
      if (answers.length === 3) renderResult();
      else renderQuestion(true);
    });
    close.addEventListener('click', closeQuiz);
    quiz.addEventListener('keydown', event => {
      if (event.key === 'Escape') {
        event.preventDefault();
        closeQuiz();
      }
    });
    quiz.hidden = true;
    launcher.hidden = false;
  }

  function boot(scope) {
    if (scope.matches && scope.matches('[data-valca-beautyweek]')) init(scope);
    scope.querySelectorAll('[data-valca-beautyweek]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document), { once: true });
  else boot(document);
  // Shared listener supports theme-editor reloads without accumulating handlers.
  if (!window.valcaBeautyWeekSectionListener) {
    document.addEventListener('shopify:section:load', event => boot(event.target));
    window.valcaBeautyWeekSectionListener = true;
  }
})();

  } catch(e) { console.error(e); }
})();
})();
